import React, { useState } from "react";
import PropTypes from "prop-types";

import GroupPreview from "components/GroupPreview";
import { groupTypes } from "domain/Groups/types";
import AnimatedModal from "components/Modal/AnimatedModal";
import ModalItem from './ModalItem'


const InvitationsListGroupItem = ({ group, players }) => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <>
            {showDetails && (
                <AnimatedModal
                    visible={true}
                    title={group.name}
                    onClose={() => setShowDetails(false)}
                    closeOnOverlay
                    modificators={["players-search"]}
                >
                    <div className="players-list players-list--modal">
                        {group.players.map((member, key) => {
                            const isPlayerSigned =
                                players.find(
                                    (player) => player.id === member.id
                                ) !== undefined;
                            const { blacklisted } = member;

                            return <ModalItem isPlayerSigned={isPlayerSigned} blacklisted = {blacklisted} key={key} member={member}/>
                        })}
                    </div>
                </AnimatedModal>
            )}
            <div
                key={`invited-group-${group.id}`}
                className="players-list__item"
            >
                <GroupPreview
                    onClick={() => setShowDetails(true)}
                    modificators={{
                        container: "group-preview_row group-preview_clickable",
                    }}
                    {...group}
                />
            </div>
        </>
    );
};

InvitationsListGroupItem.propTypes = {
    group: groupTypes,
    players: PropTypes.array,
};

export default InvitationsListGroupItem;
